<template>
  <div v-if="isDevelop && $route.path.includes('/setting/')">
    <transition name="slide-in">
      <div :class="s.map">
        <input
          id="dummy"
          type="checkbox"
          name="dummy"
          v-model="useDummy">
        <label
          :class="useDummy ? s.active : ''"
          for="dummy">
          <i :class="useDummy ? 'me-2 fa-regular fa-square-check' : 'me-2 fa-regular fa-square'"/>dummy</label>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'web-socket',
  data() {
    return {
      sessionId: null,
      ws: null, // WebSocketオブジェクトを格納するプロパティ
      useDummy: false,
      isDevelop: false,
      position: null,
      watchID: null, // watchPositionの戻り値を格納するプロパティ
      firebaseToken: null,
    };
  },
  mounted() {
    if (location.href.includes('localhost')) {
    // if (location.href.includes('https://dev') || location.href.includes('localhost')) {
      this.useDummy = true;
      this.isDevelop = true;
    }
    if (this.user.id) {
      this.initWebSocket();
    } else {
      this.$store.subscribe((mutation) => {
        if (mutation.type === 'user/setUserData') {
          this.initWebSocket();
        }
      });
    }
  },
  beforeUnmount() {
    // ネイティブアプリは何もしない
    // if (this.helper.isNative.app) return;

    // ページ遷移前にWebSocketを切断
    this.ws.close();
  },
  computed: {
    ...mapState(['user', 'layout', 'helper']),
    listOpened() {
      return this.layout.showFlags.requests || this.layout.showFlags.orders || this.layout.showFlags.driverInfo;
    },
    driverVehicleId() {
      return this.user.vehicles?.[0]?.id || null;
    },
    driverVehicleLabel() {
      return this.user.vehicles?.[0]?.label || null;
    },
    wsBaseInfo() {
      return {
        id: this.sessionId,
        sessionId: this.sessionId,
        client_type: 'driver',
        user_id: this.user.id,
        vehicle_id: this.driverVehicleId,
        vehicle_label: this.driverVehicleLabel,
        office_id: this.user.offices[0]?.id,
        firebaseToken: this.user.login.firebaseToken,
        isAppDriver: Boolean(this.user.role?.role === 13),
        isValid: true,
      };
    },
    isNative() {
      return this.helper.isNative.app;
    },
  },
  watch: {
    driverVehicleId() {
      this.updateWebSocket();
    },
    'user.login.firebaseToken': {
      handler() {
        this.updateWebSocket();
      },
    },
  },
  methods: {
    initWebSocket() {
      // ネイティブアプリは何もしない
      // if (this.helper.isNative.app) return;

      // TODO: WebSocket再接続処理
      this.ws = new WebSocket(process.env.VUE_APP_WSBASE);

      this.ws.onclose = () => {
        console.log('close');
        // 再接続
        setTimeout(() => {
          this.initWebSocket();
        }, 3000);
      };

      this.ws.onmessage = (event) => {
        this.receiveWebSocket(event);
      };

      if (this.helper.isNative.app) return;
      // 適度な間隔で位置情報を監視（Nativeでないときのみ）
      this.watchID = navigator.geolocation.watchPosition((position) => {
        const positionData = this.formatPosition(position);
        // サーバーに位置情報を送信
        if (this.ws.readyState === WebSocket.OPEN && this.sessionId && this.driverVehicleId) {
          // チェックボックスでダミーデータを使用するか切り替え
          const clientData = this.createSendPositionData(this.sessionId, positionData);
          this.ws.send(JSON.stringify(clientData));
          console.log('send');
          this.position = clientData;
        } else {
          // console.log('ws not open');
        }
      });
    },

    updateWebSocket() {
      const sendData = {
        type: 'connected',
        ...this.wsBaseInfo,
      };
      console.log('updated!');
      this.ws.send(JSON.stringify(sendData));
    },

    receiveWebSocket(e) {
      // 文字列で渡ってくるのでパース
      let client;
      try {
        client = JSON.parse(e.data);
      } catch {
        client = {};
      }
      console.log('receive!!');
      console.log(JSON.stringify(client, null, 2));
      // タイプで振り分ける
      const type = client.type;

      if (type === 'connect') {
        // 接続後にセッションidをもらう
        this.sessionId = client.sessionId;
        const sendData = {
          type: 'connected',
          ...this.wsBaseInfo,
        };
        this.ws.send(JSON.stringify(sendData));

        // 接続した段階で一度最新状態にする（別アプリから戻って再接続されたときに最新状態にするため）
        this.$store.dispatch('dispatch/getData');
        this.$store.dispatch('user/update');
        this.$store.dispatch('user/update');
        const allCountTargets = Object.keys(this.helper.updateCount);
        this.$store.dispatch('helper/countUpUpdateCount', { targets: allCountTargets });

        return;
      }
      
      if (type === 'update') {
        // 情報を更新する
        if (client.targets.includes('reservations')) this.$store.dispatch('dispatch/getData');
        if (client.targets.includes('requests')) this.$store.dispatch('user/update');
        if (client.targets.includes('user')) this.$store.dispatch('user/update');
      } else if (type === 'update-count') {
        this.$store.dispatch('helper/countUpUpdateCount', { targets: client.targets });
      }
    },

    createRandomValue(min, max, places) {
      const multiplier = 10 ** places;
      const rawNumber = Math.random() * (max - min) + min;
      return Math.round(rawNumber * multiplier) / multiplier;
    },
    formatPosition(position) {
      return {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        altitude: position.coords.altitude,
        accuracy: position.coords.accuracy,
        altitudeAccuracy: position.coords.altitudeAccuracy,
        heading: position.coords.heading,
        speed: position.coords.speed,
        timestamp: position.timestamp,
      };
    },
    createSendPositionData(id, positionData) {
      return {
        type: 'vehicle-position',
        ...this.wsBaseInfo,
        position: {
          timestamp: positionData.timestamp,
          latitude: this.useDummy ? positionData.latitude + this.createRandomValue(-0.01, 0.01, 5) : positionData.latitude,
          longitude: this.useDummy ? positionData.longitude + this.createRandomValue(-0.01, 0.01, 5) : positionData.longitude,
        },
      };
    },
  },
};
</script>

<style lang="scss" module="s">
.map {
  position: fixed;
  bottom: var(--footer-height);
  right: 0;
  z-index: 5;
  background-color: #ffffff;
  border-top: 1px solid var(--border-gray);
  width: 100%;
  input {
    display: none;
  }
  label {
    width: 100%;
    padding: 12px;
    cursor: pointer;
  }
}
</style>

<style lang="scss" scoped>
.slide-in-enter-to, .slide-in-leave-from {
  transform: translateX(0);
}
.slide-in-enter-active, .slide-in-leave-active {
  transition: transform .3s;
}
.slide-in-enter-from, .slide-in-leave-to {
  transform: translateX(calc(100% + 10px));
}
</style>
